import { ReactNode } from 'react'
import { Provider } from 'react-redux'

import { setupStore } from './StoreRoot'

const RootStoreProvider = ({ children }: { children: ReactNode }) => (
  <Provider store={setupStore()}>{children} </Provider>
)

export default RootStoreProvider
